import { useEffect, useState } from 'react';

const emptyArr = [];
export const useDebouncedIds = (ids = emptyArr) => {
  const [debouncedIds, setDebouncedIds] = useState(ids);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedIds(ids);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [ids]);

  return debouncedIds;
};
